import {OAuthPrescriptionsType} from '../../../../reducers/oAuth/oAuthType';
import {PrescriptionType} from '../../reducers/prescription/prescription/prescriptionTypes';

/**
 * Prepares the prescription to save in appropriate format for the backend
 * @param {PrescriptionType} prescription - prescription before formatting
 * @returns {PrescriptionType} - prescription after formatting
 */
export const preparePrescriptionToSave = (prescription: PrescriptionType): PrescriptionType => {
    return {
        ...prescription,
        ...(prescription.isMultiPD
            ? {
                  pd: {
                      left: prescription.pd.left,
                      right: prescription.pd.right,
                      near: prescription.pd.near,
                      singular: 'None',
                  },
              }
            : {
                  pd: {
                      near: prescription.pd.near,
                      singular: prescription.pd.singular,
                      left: 'None',
                      right: 'None',
                  },
              }),
    };
};

/**
 * Converts the prescription to the format acceptable
 * by the customer MS endpoint for updating a prescription
 * @returns {object} obj
 */
export const preparePrescriptionToUpdate = ({
    od,
    os,
    pd,
    id,
    name,
    comment,
}: PrescriptionType): Omit<
    OAuthPrescriptionsType,
    'type' | 'updatedAt' | 'isSixoversix' | 'createdAt'
> => ({
    id,
    name,
    comment,
    data: {
        sph_od: od.sph,
        sph_os: os.sph,
        cyl_od: od.cyl,
        cyl_os: os.cyl,
        axi_od: od.axi,
        axi_os: os.axi,
        add_od: od.add,
        add_os: os.add,
        pd: pd.singular,
        pd_right: pd.right,
        pd_left: pd.left,
        pd_near: pd.near,
    },
});
